import { Component, OnInit, Input } from "@angular/core";
import { Order, UrgencyEnum } from "../../models/order.model";
import { AuthService } from "../../services/auth.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "order-urgency-icon",
  templateUrl: "./order-urgency-icon.component.html",
  styleUrls: ["./order-urgency-icon.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class OrderUrgencyIconComponent implements OnInit {
  @Input() order: Order;

  plantUserSw: boolean;
  labUserSw: boolean;

  constructor(private authService: AuthService) {
    this.plantUserSw = this.authService.currentUser.org == "PLANT";
    this.labUserSw = this.authService.currentUser.org == "LAB";
  }

  ngOnInit(): void {}

  getUrgencyIcon(): string {
    let urgencyCode =
      this.authService.currentUser.org == "PLANT"
        ? this.order.urgencyPlantCode
        : this.order.urgencyLabCode;
    switch (urgencyCode) {
      case UrgencyEnum.CRITICAL:
        return "assets/img/urgency/Critical.svg";
      case UrgencyEnum.HIGH:
        return "assets/img/urgency/High.svg";
      case UrgencyEnum.MED:
        return "assets/img/urgency/Medium.svg";
      case UrgencyEnum.LOW:
        return "assets/img/urgency/Low.svg";
    }
  }
}
